export default __webpack_public_path__ + "static/media/butterfly.20f07776.png";